/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  ApiResponse,
  AuthenticateResultDto,
  ClientRegisterDto,
  ClientRegistrationResultDtoApiResponse,
  GetApiAuthVerifyEmailParams,
  LoginRequestDto,
  LogoutRequestDto,
  RefreshTokenRequestDto,
  RequestPasswordResetDto,
  ResendVerificationEmailDto,
  ResetPasswordDto,
} from '../../models/generated'

import { fastmileInstance } from '../../fastmileInstance'

export const postApiAuthLogin = (
  loginRequestDto: LoginRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<AuthenticateResultDto>({
    url: '/api/Auth/login',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: loginRequestDto,
    signal,
  })
}

export const getPostApiAuthLoginMutationOptions = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthLogin>>,
    TError,
    { data: LoginRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthLogin']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthLogin>>,
  { data: LoginRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthLogin(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthLoginMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthLogin>>
>
export type PostApiAuthLoginMutationBody = LoginRequestDto
export type PostApiAuthLoginMutationError = ApiResponse

export const usePostApiAuthLogin = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthLogin>>,
    TError,
    { data: LoginRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
  > => {
  const mutationOptions = getPostApiAuthLoginMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiAuthRegister = (
  clientRegisterDto: ClientRegisterDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<ClientRegistrationResultDtoApiResponse>({
    url: '/api/Auth/register',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: clientRegisterDto,
    signal,
  })
}

export const getPostApiAuthRegisterMutationOptions = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRegister>>,
    TError,
    { data: ClientRegisterDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthRegister>>,
  TError,
  { data: ClientRegisterDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthRegister']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthRegister>>,
  { data: ClientRegisterDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthRegister(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthRegisterMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthRegister>>
>
export type PostApiAuthRegisterMutationBody = ClientRegisterDto
export type PostApiAuthRegisterMutationError = ApiResponse

export const usePostApiAuthRegister = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRegister>>,
    TError,
    { data: ClientRegisterDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthRegister>>,
  TError,
  { data: ClientRegisterDto },
  TContext
  > => {
  const mutationOptions = getPostApiAuthRegisterMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Validates the current JWT token and returns user context
 */
export const getApiAuthValidateToken = (signal?: AbortSignal) => {
  return fastmileInstance<void>({
    url: '/api/Auth/validate-token',
    method: 'GET',
    signal,
  })
}

export const getGetApiAuthValidateTokenQueryKey = () => {
  return ['/api/Auth/validate-token'] as const
}

export const getGetApiAuthValidateTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError = ApiResponse,
>(options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthValidateToken>>,
    TError,
    TData
    >
    >;
  }) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAuthValidateTokenQueryKey()

  const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>
  > = ({ signal }) => getApiAuthValidateToken(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAuthValidateTokenQueryResult = NonNullable<
Awaited<ReturnType<typeof getApiAuthValidateToken>>
>
export type GetApiAuthValidateTokenQueryError = ApiResponse

export function useGetApiAuthValidateToken<
  TData = Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError = ApiResponse,
>(options: {
  query: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  TData
  >
  > &
  Pick<
  DefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  Awaited<ReturnType<typeof getApiAuthValidateToken>>
  >,
  'initialData'
  >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiAuthValidateToken<
  TData = Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError = ApiResponse,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  TData
  >
  > &
  Pick<
  UndefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  Awaited<ReturnType<typeof getApiAuthValidateToken>>
  >,
  'initialData'
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiAuthValidateToken<
  TData = Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError = ApiResponse,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
/**
 * @summary Validates the current JWT token and returns user context
 */

export function useGetApiAuthValidateToken<
  TData = Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError = ApiResponse,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthValidateToken>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions = getGetApiAuthValidateTokenQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const postApiAuthRefreshToken = (
  refreshTokenRequestDto: RefreshTokenRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<AuthenticateResultDto>({
    url: '/api/Auth/refresh-token',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: refreshTokenRequestDto,
    signal,
  })
}

export const getPostApiAuthRefreshTokenMutationOptions = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRefreshToken>>,
    TError,
    { data: RefreshTokenRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthRefreshToken>>,
  TError,
  { data: RefreshTokenRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthRefreshToken']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthRefreshToken>>,
  { data: RefreshTokenRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthRefreshToken(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthRefreshTokenMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthRefreshToken>>
>
export type PostApiAuthRefreshTokenMutationBody = RefreshTokenRequestDto
export type PostApiAuthRefreshTokenMutationError = ApiResponse

export const usePostApiAuthRefreshToken = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRefreshToken>>,
    TError,
    { data: RefreshTokenRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthRefreshToken>>,
  TError,
  { data: RefreshTokenRequestDto },
  TContext
  > => {
  const mutationOptions = getPostApiAuthRefreshTokenMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiAuthLogout = (
  logoutRequestDto: LogoutRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<ApiResponse>({
    url: '/api/Auth/logout',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: logoutRequestDto,
    signal,
  })
}

export const getPostApiAuthLogoutMutationOptions = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthLogout>>,
    TError,
    { data: LogoutRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthLogout>>,
  TError,
  { data: LogoutRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthLogout']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthLogout>>,
  { data: LogoutRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthLogout(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthLogoutMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthLogout>>
>
export type PostApiAuthLogoutMutationBody = LogoutRequestDto
export type PostApiAuthLogoutMutationError = ApiResponse

export const usePostApiAuthLogout = <
  TError = ApiResponse,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthLogout>>,
    TError,
    { data: LogoutRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthLogout>>,
  TError,
  { data: LogoutRequestDto },
  TContext
  > => {
  const mutationOptions = getPostApiAuthLogoutMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Verifies a user's email using a verification token
 */
export const getApiAuthVerifyEmail = (
  params?: GetApiAuthVerifyEmailParams,
  signal?: AbortSignal,
) => {
  return fastmileInstance<unknown>({
    url: '/api/Auth/verify-email',
    method: 'GET',
    params,
    signal,
  })
}

export const getGetApiAuthVerifyEmailQueryKey = (
  params?: GetApiAuthVerifyEmailParams,
) => {
  return ['/api/Auth/verify-email', ...(params ? [params] : [])] as const
}

export const getGetApiAuthVerifyEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError = void | ApiResponse,
>(
    params?: GetApiAuthVerifyEmailParams,
    options?: {
      query?: Partial<
      UseQueryOptions<
      Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
      TError,
      TData
      >
      >;
    },
  ) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetApiAuthVerifyEmailQueryKey(params)

  const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getApiAuthVerifyEmail>>
  > = ({ signal }) => getApiAuthVerifyEmail(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
  Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError,
  TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAuthVerifyEmailQueryResult = NonNullable<
Awaited<ReturnType<typeof getApiAuthVerifyEmail>>
>
export type GetApiAuthVerifyEmailQueryError = void | ApiResponse

export function useGetApiAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError = void | ApiResponse,
>(
  params: undefined | GetApiAuthVerifyEmailParams,
  options: {
    query: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    TData
    >
    > &
    Pick<
    DefinedInitialDataOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>
    >,
    'initialData'
    >;
  },
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError = void | ApiResponse,
>(
  params?: GetApiAuthVerifyEmailParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    TData
    >
    > &
    Pick<
    UndefinedInitialDataOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>
    >,
    'initialData'
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError = void | ApiResponse,
>(
  params?: GetApiAuthVerifyEmailParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
/**
 * @summary Verifies a user's email using a verification token
 */

export function useGetApiAuthVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
  TError = void | ApiResponse,
>(
  params?: GetApiAuthVerifyEmailParams,
  options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyEmail>>,
    TError,
    TData
    >
    >;
  },
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions = getGetApiAuthVerifyEmailQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const postApiAuthResendVerificationEmail = (
  resendVerificationEmailDto: ResendVerificationEmailDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<void>({
    url: '/api/Auth/resend-verification-email',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resendVerificationEmailDto,
    signal,
  })
}

export const getPostApiAuthResendVerificationEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>,
    TError,
    { data: ResendVerificationEmailDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>,
  TError,
  { data: ResendVerificationEmailDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthResendVerificationEmail']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>,
  { data: ResendVerificationEmailDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthResendVerificationEmail(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthResendVerificationEmailMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>
>
export type PostApiAuthResendVerificationEmailMutationBody =
  ResendVerificationEmailDto
export type PostApiAuthResendVerificationEmailMutationError = unknown

export const usePostApiAuthResendVerificationEmail = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>,
    TError,
    { data: ResendVerificationEmailDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthResendVerificationEmail>>,
  TError,
  { data: ResendVerificationEmailDto },
  TContext
  > => {
  const mutationOptions =
    getPostApiAuthResendVerificationEmailMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiAuthRequestPasswordReset = (
  requestPasswordResetDto: RequestPasswordResetDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<void>({
    url: '/api/Auth/request-password-reset',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestPasswordResetDto,
    signal,
  })
}

export const getPostApiAuthRequestPasswordResetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>,
    TError,
    { data: RequestPasswordResetDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>,
  TError,
  { data: RequestPasswordResetDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthRequestPasswordReset']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>,
  { data: RequestPasswordResetDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthRequestPasswordReset(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthRequestPasswordResetMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>
>
export type PostApiAuthRequestPasswordResetMutationBody =
  RequestPasswordResetDto
export type PostApiAuthRequestPasswordResetMutationError = unknown

export const usePostApiAuthRequestPasswordReset = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>,
    TError,
    { data: RequestPasswordResetDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthRequestPasswordReset>>,
  TError,
  { data: RequestPasswordResetDto },
  TContext
  > => {
  const mutationOptions =
    getPostApiAuthRequestPasswordResetMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiAuthResetPassword = (
  resetPasswordDto: ResetPasswordDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<void>({
    url: '/api/Auth/reset-password',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resetPasswordDto,
    signal,
  })
}

export const getPostApiAuthResetPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthResetPassword>>,
    TError,
    { data: ResetPasswordDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
  > => {
  const mutationKey = ['postApiAuthResetPassword']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiAuthResetPassword>>,
  { data: ResetPasswordDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiAuthResetPassword(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiAuthResetPasswordMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiAuthResetPassword>>
>
export type PostApiAuthResetPasswordMutationBody = ResetPasswordDto
export type PostApiAuthResetPasswordMutationError = unknown

export const usePostApiAuthResetPassword = <
  TError = unknown,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthResetPassword>>,
    TError,
    { data: ResetPasswordDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthResetPassword>>,
  TError,
  { data: ResetPasswordDto },
  TContext
  > => {
  const mutationOptions = getPostApiAuthResetPasswordMutationOptions(options)

  return useMutation(mutationOptions)
}
